import { ref, watch } from 'vue';
import { defineStore } from 'pinia';
import { useRoute } from 'vue-router';
import statsApi from '../api/stats.api';

const FEATURE_ROUTE_MAP  = {
	'job-board' : 'job_board_ai',
	resume : 'resume_ai',
	network : 'network_ai',
	'cover-letter' : 'cover_letter_ai',
	interview : 'interview_ai',
	community : 'resume_share',
};

export const useAuthPopupStore = defineStore('auth-popup', () => {
	const route = useRoute();
	const FEATURE_NAMES = Object.keys(FEATURE_ROUTE_MAP);

	const showAuthPopup = ref(false);
	const showPopupOpenAnimation = ref(false);
	const activeFeature = ref(null);

	const trackModalOpenHandler = async () => {
		await statsApi.trackAuthPopupOpen({
			modal_name: activeFeature.value
		});
	};

	watch(route, (newRoute) => {
		const routeName = newRoute.name;

		const featurePrefix = FEATURE_NAMES.find((feature) => {
			return routeName?.startsWith(feature);
		});

		if (featurePrefix == null) {
			activeFeature.value = null;
		} else {
			activeFeature.value = FEATURE_ROUTE_MAP[featurePrefix];
		}
	});

	watch(route, () => {
		showAuthPopup.value = false;
	});

	const setShowAuthPopup = (afterLoginRedirectRouteName = null) => {
		const isValidRouteName = typeof afterLoginRedirectRouteName === 'string'
			&& afterLoginRedirectRouteName.length > 0;

		if (isValidRouteName) {
			localStorage.setItem('redirectAfterLoginTo', afterLoginRedirectRouteName);
		} else {
			localStorage.removeItem('redirectAfterLoginTo');
		}

		if (showAuthPopup.value === true) {
			showPopupOpenAnimation.value = true;

			setTimeout(() => {
				showPopupOpenAnimation.value = false;
			}, 1100);
		} else {
			showAuthPopup.value = true;
			trackModalOpenHandler();
		}
	};

	const hideShowAuthPopup = () => {
		localStorage.removeItem('redirectAfterLoginTo');

		showPopupOpenAnimation.value = false;
		showAuthPopup.value = false;
	};

	return {
		showAuthPopup,
		activeFeature,
		showPopupOpenAnimation,

		setShowAuthPopup,
		hideShowAuthPopup
	};
});
